import React from "react";
import {
  QueryUsersViewingPages,
  SubscribeUserViewingPageUpdate,
  SubscribeNewLogUpdate,
  QueryLogs,
  QueryConnectedServices,
  SubscribeConnectedServiceUpdate,
  QueryServerTime,
  SubscribeNewServerTimeUpdate,
} from "../../../utils/graphql/hooks/adminHooks";

export default function AdminDataManager() {
  QueryUsersViewingPages();
  SubscribeUserViewingPageUpdate();
  QueryLogs();
  SubscribeNewLogUpdate();
  QueryConnectedServices();
  SubscribeConnectedServiceUpdate();
  QueryServerTime();
  SubscribeNewServerTimeUpdate();
  return <></>;
}
